import React, { useRef, useState } from "react";
import { Row, Col, Form, Card, Button, Dropdown } from "react-bootstrap";
import { Filter, RotateCcw } from "lucide-react";
const styles = {
  card: { border: "1px solid #E5E7EB", borderRadius: 12, boxShadow: "none" },
  filtersLabel: { fontSize: 13, fontWeight: 600, color: "#374151" },
  fieldLabel: { fontSize: 12, color: "#6B7280", marginBottom: 4 },
  input: {
    border: "1px solid #D1D5DB",
    borderRadius: 8,
    fontSize: 13.5,
    height: 38,
  },
  btnReset: {
    border: "1px solid #D1D5DB",
    color: "#374151",
    background: "#fff",
    borderRadius: 8,
    fontSize: 13.5,
    fontWeight: 500,
  },
  
};

const ReportFilters = ({
  fromDate,
  toDate,
  selectedUser,
  selectedModule,
  groupBy,
  employeeUsers,
  modules,
  errors,
  onFromDateChange,
  onToDateChange,
  onUserChange,
  onModuleChange,
  onGroupByChange,
  onReset,
}) => {
  const fromDateRef = useRef(null);
  const toDateRef = useRef(null);
  const [empOpen, setEmpOpen] = useState(false);
  const [empSearch, setEmpSearch] = useState("");

  const selectedEmpName =
    employeeUsers.find((u) => String(u.id) === String(selectedUser))?.name ||
    "All Employees";

  const filteredEmployees = employeeUsers.filter((u) =>
    (u.name || "").toLowerCase().includes(empSearch.trim().toLowerCase())
  );

  const pickEmployee = (id) => {
    onUserChange(id);
    setEmpOpen(false);
    setEmpSearch("");
  };

  return (
    <Card className="mb-3" style={styles.card}>
      <Card.Body>
        <div className="d-flex align-items-center mb-3">
          <Filter size={15} className="me-2" />
          <span style={styles.filtersLabel}>Filters</span>
        </div>
        <Row className="gy-3">
          <Col md={2}>
            <Form.Label style={styles.fieldLabel}>
              From Date <span className="text-danger">*</span>
            </Form.Label>
            <Form.Control
              type="date"
              ref={fromDateRef}
              value={fromDate}
              style={{ ...styles.input, cursor: "pointer" }}
              onClick={() => fromDateRef.current?.showPicker?.()}
              onChange={(e) => onFromDateChange(e.target.value)}
            />
            {errors.date && (
              <div className="text-danger small mt-1">{errors.date}</div>
            )}
          </Col>

          <Col md={2}>
            <Form.Label style={styles.fieldLabel}>To Date</Form.Label>
            <Form.Control
              type="date"
              ref={toDateRef}
              value={toDate}
              min={fromDate}
              style={{ ...styles.input, cursor: "pointer" }}
              onClick={() => toDateRef.current?.showPicker?.()}
              onChange={(e) => onToDateChange(e.target.value)}
            />
          </Col>

          <Col md={3}>
            <Form.Label style={styles.fieldLabel}>Employee</Form.Label>
            <Dropdown
              show={empOpen}
              autoClose="outside"
              onToggle={(open) => {
                setEmpOpen(open);
                if (!open) setEmpSearch("");
              }}
            >
              <Dropdown.Toggle
                variant="light"
                className="w-100 d-flex justify-content-between align-items-center text-start"
                style={{ ...styles.input, background: "#fff", fontWeight: 400 }}
              >
                <span className="text-truncate">{selectedEmpName}</span>
              </Dropdown.Toggle>

              <Dropdown.Menu className="w-100 p-2">
                <Form.Control
                  size="sm"
                  autoFocus
                  placeholder="Search employee..."
                  value={empSearch}
                  onChange={(e) => setEmpSearch(e.target.value)}
                />
                <div style={{ maxHeight: 220, overflowY: "auto" }} className="mt-2">
                  {!empSearch.trim() && (
                    <Dropdown.Item
                      active={selectedUser === ""}
                      onClick={() => pickEmployee("")}
                    >
                      All Employees
                    </Dropdown.Item>
                  )}
                  {filteredEmployees.map((u) => (
                    <Dropdown.Item
                      key={u.id}
                      active={String(selectedUser) === String(u.id)}
                      onClick={() => pickEmployee(String(u.id))}
                    >
                      {u.name}
                    </Dropdown.Item>
                  ))}
                  {filteredEmployees.length === 0 && (
                    <div className="text-muted small px-3 py-2">No employees found</div>
                  )}
                </div>
              </Dropdown.Menu>
            </Dropdown>
          </Col>

          <Col md={3}>
            <Form.Label style={styles.fieldLabel}>Project Module</Form.Label>
            <Form.Select
              style={styles.input}
              value={selectedModule}
              onChange={(e) => onModuleChange(e.target.value)}
            >
              <option value="">All Modules</option>
              {modules.map((m) => (
                <option key={m.id} value={m.id}>
                  {m.name}
                </option>
              ))}
            </Form.Select>
          </Col>

          <Col md={2}>
            <Form.Label style={styles.fieldLabel}>Sort By</Form.Label>
                        <Form.Select
              style={styles.input}
              value={groupBy}
              onChange={(e) => onGroupByChange(e.target.value)}
            >
              <option value="">All Date Type</option>
              <option value="working">Working Date</option>
              <option value="reported">Reported Date</option>
            </Form.Select>
          </Col>
        </Row>

       <div className="text-end mt-3">
          <Button
            variant="outline-secondary"
            style={styles.btnReset}
            onClick={onReset}
          >
            <RotateCcw size={15} className="me-1" /> Reset Filters
          </Button>
        </div>
      </Card.Body>
    </Card>
  );
};

export default ReportFilters;
